import React from "react";
import EventIcons from "./EventIcons";

const CardDetails = ({ eventDetails }) => {
    return (
        <>
            <div
                style={{
                    width: "10%",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <EventIcons background={eventDetails?.type?.background} />
                <p
                    style={{
                        fontWeight: "700",
                    }}
                >
                    {eventDetails?.suspensionTime?.minutes &&
                        eventDetails.suspensionTime.minutes + "'"}
                </p>
            </div>
            <div
                style={{
                    width: "35%",
                }}
            >
                {eventDetails?.playerSelected?.playerNumber && (
                    <span
                        style={{
                            marginRight: 5,
                        }}
                    >
                        {eventDetails?.playerSelected?.playerNumber}
                    </span>
                )}
                <span style={{}}>
                    {eventDetails?.playerSelected?.playerName ||
                        eventDetails?.playerSelected?.contactName}
                </span>
            </div>
            <div
                style={{
                    width: "15%",
                }}
            >
                <span style={{}}>{eventDetails?.sideSelected?.teamName}</span>
            </div>
        </>
    );
};

export default CardDetails;
